import { getEnvironmentVar } from '../getEnvironmentVar';

function getBearerTokenAuthEnabledConfig(): string | undefined {
  return getEnvironmentVar('REACT_APP_BEARER_TOKEN_AUTH_ENABLED');
}

export function isBearerTokenAuthEnabled(): boolean {
  return getBearerTokenAuthEnabledConfig()?.toLowerCase() !== 'false';
}

export function isCookieAuthEnabled(): boolean {
  return !isBearerTokenAuthEnabled();
}
